<template><!-- svgo-optimised -->
<svg class="icon icon__menu icon--no-fill" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M3 4.5h18M3 11.5h18M3 18.5h18" stroke="#000"/></svg>
</template>